//简体中文
export default {
  Login: {
    Title: "登录您的账户",
    describe: "请登录或创建一个账户以开始使用。",
    Google: " 继续使用 Google",
    Apple: " 继续使用 Apple",
    or: "或者",
    Emailplaceholder: "电子邮件地址",
    Passwordplaceholder: "密码",
    Login: "登录",
    forgot: "忘记密码？",
    notAccount: "还没有 Fineshare 账户？",
    Signup: "注册",
    InvalidEmail: "无效的邮箱格式。",
    InvalidPassword: "密码必须至少为 6 个字符。",
    loading: "加载中..",
    login: "登录",
    errorText: "登录失败，请检查您的用户名和密码",
  },
  signup: {
    Title: "创建您的账户",
    describe: "几秒钟内创建您的 Fineshare 账户。",
    Google: "使用 Google 注册",
    Apple: "使用 Apple 注册",
    or: "或者",
    Emailplaceholder: "请输入邮箱地址",
    Passwordplaceholder: "请输入6位密码",
    Already: "已经有账户了？",
    Login: "登录",
    By: "通过创建账户，我同意我已阅读并接受",
    Privacy: "隐私政策",
    Terms: "使用条款。",
    and: "和",
    signupText: "创建您的账户",
    InvalidEmail: "无效的邮箱格式。",
    InvalidPassword: "密码必须至少为 6 个字符。",
    loading: "加载中..",
    passwordError: "该邮箱地址已被注册",
    again: "您请求过于频繁，请稍后再试",
    Registration: "注册失败，请检查您的邮箱和密码。",
    hasRegistered: "该邮箱地址已被注册",
  },
  Home: {
    Welcome: "欢迎来到 Fineshare 帐户中心",
  },
};
